<template>
    <div class="w-full h-screen flex flex-col-reversed">
        <div
            class="bg-white dark:bg-gray-900 flex flex-col justify-center items-center w-full md:w-6/12 lg:w-5/12 xl:w-4/12 relative">
            <div class="w-full max-w-xs px-5 sm:px-0">
                <div>
                    <img alt="AIW Storemanager" class="h-full w-auto dark:hidden"
                         src="../../../assets/images/Logo_AIW.svg">
                    <img alt="AIW Storemanager" class="h-full w-auto hidden dark:block"
                         src="../../../assets/images/Logo_AIW_dark.svg">
                </div>
                <login-form v-if="mode === 'login'" @change-mode="mode = $event"/>
                <forgot-password-form v-if="mode === 'forgot'" @change-mode="mode = $event"/>
                <reset-password-form v-if="mode === 'reset'" @change-mode="mode = $event"/>
            </div>
            <div
                class="absolute bottom-0 left-0 w-full border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 p-3 flex items-center justify-between">
                <locale-toggle/>
                <dark-mode-toggle/>
            </div>
        </div>
        <div class="h-screen w-0 md:w-6/12 lg:w-7/12 xl:w-8/12 relative">
            <div
                class="login-gradient absolute top-0 left-0 w-full h-screen opacity-50"></div>
            <img alt="background" class="h-screen object-cover object-right-bottom"
                 src="../../../assets/images/AIW_Stores_Map.png">
        </div>
    </div>
</template>

<script>
import LocaleToggle from '../../Components/Base/LocaleToggle';
import DarkModeToggle from '../../Components/Base/DarkModeToggle';
import LoginForm from '@/Pages/Auth/Components/LoginForm';
import ForgotPasswordForm from '@/Pages/Auth/Components/ForgotPasswordForm';
import ResetPasswordForm from '@/Pages/Auth/Components/ResetPasswordForm';
import URL from '@/Utilities/URL';

export default {
    components: {ResetPasswordForm, LoginForm, ForgotPasswordForm, LocaleToggle, DarkModeToggle},

    props: {
        resetToken: {

        },
    },

    data() {
        return {
            mode: 'login',
        };
    },

    created() {
        let urlParams = URL.parameters();
        let initialMode = urlParams.get('mode');

        this.mode = initialMode ?? this.mode;
    },

    metaInfo() {
        return {
            title: () => {
                if (this.mode === 'login') {
                    return this.$t('auth.login');
                }

                if (this.mode === 'forgot') {
                    return this.$t('auth.forgot_password');
                }

                if (this.mode === 'reset') {
                    return this.$t('auth.reset_password');
                }

                return null;
            },
            titleTemplate: '%s | Storemanager',
        }
    },
};
</script>

<style>
.dark .login-gradient {
    background: rgb(0, 0, 0);
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0) 100%);
}
</style>
